import { render, staticRenderFns } from "./FormesJuridiques.vue?vue&type=template&id=20e61d66&"
import script from "./FormesJuridiques.vue?vue&type=script&lang=js&"
export * from "./FormesJuridiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports